export default function Style(){
  return (
    <style>
      {`
      .aminitiesCard {
  background-image: linear-gradient(rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0.5) 100%),
    url( /static/images/landingPages/aminities1.png);
  background-size: cover;
  color: white;
}

.aminitiesCard2 {
  background-image: linear-gradient(rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0.5) 100%),
    url( /static/images/landingPages/aminities2.png);
  background-size: cover;
  color: white;

}

.aminitiesCard3 {
  background-image: linear-gradient(rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0.5) 100%),
    url( /static/images/landingPages/aminities3.png);
  color: white;
  background-size: cover;
}
 

      `}
    </style>
  );
}
